import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './DeleteModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
  
const BookingDeleteModal = ({ BookingService, defaultBooking }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const confirmDelete = () => { 
        console.log("Deleted id: ", defaultBooking.id)
        BookingService.remove(defaultBooking.id)
            .then((response) => {
                setIsModalOpen(false) 
            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return (
        <div>
            <span className={ css.removeBtn } onClick={() => openDelete()} ><Remove/> წაშლა</span> 
           
            <Modal key={defaultBooking.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>

                <div className={css.modalHead }><h3>წაშლა</h3></div> 
                <div className={ css.message } >გსურთ მომხმარებლის წაშლა?</div>
                <div className={ css.buttons }>
                    <button className={ css.removeBtnYes } onClick={confirmDelete}>დიახ მსურს!</button> 
                </div> 
            </Modal>


        </div>
    );
};

export default BookingDeleteModal;